/**
 *
 * Hero Event Introduction Block
 *
 * Handling event timer
 */

jQuery(document).ready(function () {

    
    // Set the date we're counting down to
    var countDownDate = new Date(jQuery('.starteDateHidden').text().replace(/\s/, 'T')).getTime();

    // Update the count down every 1 second
    var timerId = setInterval(function () {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="counter"
        if(document.getElementById("timerDays")) {
            document.getElementById("timerDays").innerHTML = days;
            document.getElementById("timerHours").innerHTML = hours;
            document.getElementById("timerMinutes").innerHTML = minutes;
            document.getElementById("timerSeconds").innerHTML = seconds;
        }
        
        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(timerId);
            //document.getElementById("counter").innerHTML = "EXPIRED";
        }
    }, 1000);

    jQuery('.animation-holder-intro-block').each(function (i, animation) {
        var animationIdHolder = animation.id;
        var currentAnimation = bodymovin.loadAnimation({
            container: document.getElementById(animation.id),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: window.ITBL.assets+'/animations/Animation_Hero_' + animationIdHolder + '.json'
        });
    })

});